import { Product as e, ProductInfo as T, Environment as f } from "cerulean/dist/lib/product";
import { ONE_NAV_SUBDOMAIN_RE as E } from "../lib/location.js";
import { isInStorybook as C, isInOneNav as u } from "./is-in-onenav.js";
const w = (window == null ? void 0 : window.__ENVIRONMENT__) ?? "local", s = window == null ? void 0 : window.__CURRENTAPP__, d = s === e.ANALYTICS, I = s === e.AUDIENCES, S = s === e.DATA, _ = s === e.EXPERIMENT, h = s === e.EXPLORER, R = s === e.ASSISTANCE, x = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.DATA, U = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.ANALYTICS, g = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.AUDIENCES, p = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.EXPERIMENT, v = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.ASSISTANCE, L = () => I ? e.AUDIENCES : S ? e.DATA : _ ? e.EXPERIMENT : R ? e.ASSISTANCE : e.ANALYTICS, P = {
  [e.ANALYTICS]: {
    fallbackHost: process.env.REACT_APP_ANALYTICS_HOST ?? "",
    isIn: d
  },
  [e.AUDIENCES]: {
    fallbackHost: process.env.REACT_APP_CEREBRO_HOST ?? "",
    isIn: I
  },
  [e.DATA]: {
    fallbackHost: process.env.REACT_APP_STARGATE_HOST ?? "",
    isIn: S
  },
  [e.EXPERIMENT]: {
    fallbackHost: process.env.REACT_APP_SKYLAB_HOST ?? "",
    isIn: _
  },
  [e.EXPLORER]: {
    fallbackHost: process.env.REACT_APP_EXPLORER_HOST ?? "",
    isIn: h
  },
  [e.ASSISTANCE]: {
    fallbackHost: process.env.REACT_APP_ASSISTANCE_HOST ?? "",
    isIn: R
  }
}, a = (t) => t != null && t.length && t.charAt(0) !== "/" ? `/${t}` : t, X = (t) => t != null && t.length && t.charAt(t.length - 1) === "/" ? t.slice(0, -1) : t, l = (t) => {
  if (C())
    return "";
  if (!u()) {
    if (P[t].isIn)
      return "";
    const n = T[t].urls[w];
    return n || P[t].fallbackHost || T[t].urls[f.PRODUCTION];
  }
  return `/${t}`;
}, o = (t) => (n) => {
  const A = l(t);
  if (typeof n == "string") {
    const c = a(n) || "";
    return c.match(E) ? {
      pathname: c
    } : {
      pathname: A + c
    };
  }
  const r = a(n.pathname) || "";
  return r.match(E) ? {
    pathname: r
  } : {
    ...n,
    pathname: A + r
  };
}, i = (t) => (n) => {
  const A = l(t), r = a(n) || "";
  return r.match(E) ? r || "" : A + r;
}, k = o(
  e.ANALYTICS
), y = i(
  e.ANALYTICS
), M = o(
  e.AUDIENCES
), Y = i(
  e.AUDIENCES
), $ = o(e.DATA), b = i(e.DATA), B = o(
  e.EXPERIMENT
), W = i(
  e.EXPERIMENT
), V = o(
  e.EXPLORER
), j = i(
  e.EXPLORER
), G = o(
  e.ASSISTANCE
), K = i(
  e.ASSISTANCE
), q = (t) => typeof t == "object" && t.pathname ? `${t.pathname}${t.search ? `?${t.search}` : ""}` : t;
export {
  a as addLeadingSlash,
  q as coerceLocationToPathname,
  s as currentApp,
  L as getCurrentProduct,
  U as getIsInAnalytics,
  v as getIsInAssistance,
  g as getIsInAudiences,
  x as getIsInData,
  p as getIsInExperiment,
  d as isInAnalytics,
  R as isInAssistance,
  I as isInAudiences,
  S as isInData,
  _ as isInExperiment,
  h as isInExplorer,
  X as removeTrailingSlash,
  k as rewriteToAnalytics,
  y as rewriteToAnalyticsPath,
  G as rewriteToAssistance,
  K as rewriteToAssistancePath,
  M as rewriteToAudiences,
  Y as rewriteToAudiencesPath,
  $ as rewriteToData,
  b as rewriteToDataPath,
  B as rewriteToExperiment,
  W as rewriteToExperimentPath,
  V as rewriteToExplorer,
  j as rewriteToExplorerPath
};
//# sourceMappingURL=routing.js.map
